import React from 'react';
import LastaTemplate from '@Containers/Questions/LastaTemplate';
import DefaultTemplate from '@Containers/Questions/DefaultTemplate';
import PropTypes from 'prop-types';
import OldTemplate from '@Containers/Questions/OldTemplate';

const QuestionsScreen = ({ variant = '' }) => {
  switch (variant) {
    case 'lasta':
      return <LastaTemplate />;
    case 'oldTemplate':
      return <OldTemplate />;
    default:
      return <DefaultTemplate />;
  }
};

export default QuestionsScreen;

QuestionsScreen.propTypes = {
  variant: PropTypes.string,
};
